import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, extractError } from '@/lib/api.js';
import { FieldTip } from '@/components/FieldTip.js';
import { PublicAuthShell } from '@/components/layout/PublicAuthShell.js';
import { Button } from '@/components/ui/Button.js';
import { PasswordInput } from '@/components/ui/PasswordInput.js';

export function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const token = sp.get('token') ?? '';
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);

  if (!token) {
    return (
      <PublicAuthShell title="Link inválido" backTo="/esqueci-senha" backLabel="Solicitar novo link">
        <p className="text-sm text-feedback">Este link de redefinição não é válido ou expirou.</p>
      </PublicAuthShell>
    );
  }

  return (
    <PublicAuthShell title="Nova senha" subtitle="Escolha uma nova senha para sua conta">
      <form
        className="flex flex-col gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          setErr(null);
          void api
            .post('/auth/reset-password', { token, password })
            .then(() => nav('/login'))
            .catch((ex) => setErr(extractError(ex).message));
        }}
      >
        <div className="flex flex-col gap-2">
          <FieldTip label="Nova senha" hint="Mínimo 8 caracteres.">
            <PasswordInput
              id="new-password"
              value={password}
              onChange={setPassword}
              minLength={8}
              required
              autoComplete="new-password"
            />
          </FieldTip>
        </div>
        {err ? <p className="text-sm text-feedback">{err}</p> : null}
        <Button type="submit" style={{ width: '100%', padding: '12px 16px' }}>
          Redefinir senha
        </Button>
      </form>
    </PublicAuthShell>
  );
}
